import React from "react";

/** Circular minus icon used for the per-row remove button */
export function RemoveIcon(props) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <circle cx="9" cy="9" r="8" stroke="currentColor" strokeWidth="1.3" />
      <line x1="5.5" y1="9" x2="12.5" y2="9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}

const BADGE_MAP = {
  doc: { label: "DOC", className: "udm-badge--doc" },
  docx: { label: "DOC", className: "udm-badge--doc" },
  pdf: { label: "PDF", className: "udm-badge--pdf" },
  xls: { label: "XLS", className: "udm-badge--xls" },
  xlsx: { label: "XLS", className: "udm-badge--xls" },
  csv: { label: "XLS", className: "udm-badge--xls" },
  jpg: { label: "IMA", className: "udm-badge--ima" },
  jpeg: { label: "IMA", className: "udm-badge--ima" },
  png: { label: "IMA", className: "udm-badge--ima" },
  gif: { label: "IMA", className: "udm-badge--ima" },
  webp: { label: "IMA", className: "udm-badge--ima" },
};

/** Small colored extension badge (DOC / PDF / XLS / IMA) shown next to each file name */
export function FileTypeBadge({ fileName }) {
  const ext = fileName.split(".").pop().toLowerCase();
  const match = BADGE_MAP[ext] || {
    label: ext.slice(0, 3).toUpperCase() || "FILE",
    className: "udm-badge--default",
  };
  return <span className={`udm-badge ${match.className}`}>{match.label}</span>;
}